import { newE2EPage } from "@stencil/core/testing";

const testMenuItemsNested = [
    {
        name: "item-1",
        label: "Level 0",
        items: [
            {
                name: "item-1-1",
                label: "Level 1",
                items: [
                    {
                        name: "item-1-1-1",
                        label: "Level 2"
                    },
                    {
                        name: "item-1-1-2",
                        label: "Level 2"
                    }
                ]
            }
        ]
    }
];

describe("uic-header-menu", () => {
    it("should handle mouse and keyboard events correctly and emit uicMenuChange event when an item is selected", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-header-menu name="test-menu">
                <uic-header-menu-item name="menu-item-1" selected="true">
                    Menu Item 1
                </uic-header-menu-item>
                <uic-header-menu-item name="menu-item-2" icon="uic:apps">
                    Menu Item 2
                </uic-header-menu-item>
                <uic-header-menu-item name="menu-item-3" icon="uic:apps" label="Menu Item 3"></uic-header-menu-item>
                <uic-header-menu-item name="menu-item-4" trailing-icon="uic:apps">
                    Menu Item 4
                </uic-header-menu-item>
                <uic-header-menu-item name="menu-item-5" icon="uic:user" label="Menu Item 5" icon-only="true">

                </uic-header-menu-item>
            </uic-header-menu>`);
        const uicMenuChange = await page.spyOnEvent("uicMenuChange");

        const menu = await page.find("uic-header-menu.hydrated");
        const item2 = await page.find("uic-header-menu-item[name=menu-item-2].hydrated");
        const item3 = await page.find("uic-header-menu-item[name=menu-item-3].hydrated");

        // Initial current value
        expect(menu.getAttribute("current")).toEqual("menu-item-1");

        // Mouse events
        await item2.click();
        await expect(uicMenuChange).toHaveReceivedEventDetail({
            name: "test-menu",
            current: "menu-item-2"
        });
        await page.waitForChanges();
        expect(menu.getAttribute("current")).toEqual("menu-item-2");

        // Keyboard events
        await item2.press("ArrowRight");
        await item3.press("Enter");
        expect(uicMenuChange).toHaveReceivedEventDetail({
            name: "test-menu",
            current: "menu-item-3"
        });
        await page.waitForChanges();
        expect(menu.getAttribute("current")).toEqual("menu-item-3");

        // expect(menu).toMatchSnapshot();
    });

    it("should render nested menu items correctly", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-header-menu name="test-menu"></uic-header-menu>`);
        const uicMenuChange = await page.spyOnEvent("uicMenuChange");
        const menu = await page.find("uic-header-menu.hydrated");

        menu.setProperty("items", testMenuItemsNested);
        await page.waitForChanges();

        const rootItem = await page.find("uic-header-menu-item[name=item-1].hydrated");
        let nestedItem;
        // expand level 1
        await rootItem.click();
        await page.waitForChanges();
        // expand level 2
        nestedItem = await page.find("uic-header-menu-item[name=item-1-1].hydrated");
        await nestedItem.click();
        await page.waitForChanges();

        // select nested item
        nestedItem = await page.find("uic-header-menu-item[name=item-1-1-2].hydrated");
        await nestedItem.click();
        await page.waitForChanges();

        await expect(uicMenuChange).toHaveReceivedEventDetail({
            name: "test-menu",
            current: "item-1-1-2"
        });

        // is menu updated correctly
        expect(menu.getAttribute("current")).toEqual("item-1-1-2");
        expect(rootItem.getProperty("selected")).toBeTruthy();

        expect(menu).toMatchSnapshot();
    });
});
